












































import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "../../plugins";
import { mapState, mapActions } from "vuex";
export default Vue.extend({
  name: "ChangePass",
  data() {
    const validatePass = (rule: any, value: string, callback: any) => {
      // @ts-ignore
      if (value !== this.ruleForm.newPwd) {
        callback("两次密码不一致");
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        oldPwd: "",
        newPwd: "",
        newPwd2: ""
      },
      rules: {
        oldPwd: [{ required: true, type: "string", trigger: "change" }],
        newPwd: [
          {
            required: true,
            type: "string",
            trigger: "change",
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{12,24}$/
          }
        ],
        newPwd2: [
          { required: true, type: "string", trigger: "blur" },
          { validator: validatePass, trigger: "change" }
        ]
      },
      dialog: false,
      loading: false
    };
  },
  computed: {
    ...mapState("LoginInfo", ["userinfo"])
  },
  methods: {
    ...mapActions("LoginInfo", ["logout"]),
    toLogin() {
      this.logout().then(() => {
        this.$router.replace({ name: "Login" });
      });
    },
    show() {
      this.dialog = true;
    },
    quit() {
      this.ruleForm = {
        oldPwd: "",
        newPwd: "",
        newPwd2: ""
      };
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
        this.dialog = false;
      });
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(vakid => {
        if (vakid) {
          this.edit();
        }
      });
    },
    edit() {
      this.loading = true;
      axios
        .put(`/user/pwd`, {
          userId: this.userinfo.userId,
          oldPwd: this.ruleForm.oldPwd,
          newPwd: this.ruleForm.newPwd
        })
        .then(() => {
          this.$message.success("密码修改成功");
          this.quit();
          this.toLogin();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
